/* LaSirèn V13.5.0 — The Sirens / LaSirèn Lagoon
   Production-oriented storefront layer:
   - clean permanent Lagoon URLs + server-signed last-click attribution
   - shoppable Lagoon content + product hotspots
   - creator product curation + shareable Looks
   - mobile content studio with draggable hotspots
   - Shopify App Proxy backend integration for secure upload/moderation/persistence
   - analytics hooks (CustomEvent + dataLayer when available)

   IMPORTANT: commission approval/payouts remain server-side responsibilities.
*/
(function () {
  'use strict';

  var L = window.LaSiren || (window.LaSiren = {});
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var isFr = ((document.documentElement.lang || 'fr').toLowerCase().indexOf('fr') === 0);
  var REF_DAYS = Math.max(1, Math.min(90, Number((L.lagoon && L.lagoon.referralDays) || 30)));
  var privacyReady = false;
  var privacyApiAvailable = false;
  var privacyResolve;
  var privacyReadyPromise = new Promise(function (resolve) { privacyResolve = resolve; });

  function privacyAllows(kind) {
    if (!privacyReady) return false;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacyApiAvailable || !cp) return true;
    try {
      if (kind === 'marketing') return !!cp.marketingAllowed();
      if (kind === 'analytics') return !!cp.analyticsProcessingAllowed();
      return true;
    } catch (e) { return false; }
  }
  function loadPrivacyApi(done) {
    var called = false;
    function finish(available) {
      if (called) return;
      called = true;
      privacyReady = true;
      privacyApiAvailable = !!available;
      if (privacyResolve) { privacyResolve(); privacyResolve = null; }
      if (done) done();
    }
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) return finish(true);
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name:'consent-tracking-api', version:'0.1' }], function (error) {
          finish(!error && !!(window.Shopify && window.Shopify.customerPrivacy));
        });
        setTimeout(function () { finish(!!(window.Shopify && window.Shopify.customerPrivacy)); }, 1800);
        return;
      }
    } catch (e) {}
    finish(false);
  }

  function rootPath(path) {
    var root = (L.routes && L.routes.root) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    root = String(root || '/');
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(path || '').replace(/^\/+/, '');
  }

  var backendSessionPromise = null;
  var backendState = { csrf:'', me:null };
  function lagoonBackendEnabled() { return !!(L.lagoon && L.lagoon.backendEnabled && L.lagoon.apiPath); }
  function lagoonApi(path) { return String((L.lagoon && L.lagoon.apiPath) || '/apps/lasiren-lagoon').replace(/\/$/,'') + path; }
  function ensureBackendSession(force) {
    if (!lagoonBackendEnabled()) return Promise.resolve(null);
    if (force) backendSessionPromise = null;
    if (backendSessionPromise) return backendSessionPromise;
    backendSessionPromise = fetch(lagoonApi('/me'), { headers:{'Accept':'application/json'}, credentials:'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('lagoon session'); return r.json(); })
      .then(function (data) { backendState.me = data; backendState.csrf = data.csrf || ''; return data; })
      .catch(function () { backendSessionPromise = null; return null; });
    return backendSessionPromise;
  }
  function lagoonSessionId() {
    var key = 'lasiren_lagoon_session_v13', id = '';
    try { id = localStorage.getItem(key) || ''; } catch (e) {}
    if (!id) {
      try { id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('ls_' + Date.now().toString(36) + Math.random().toString(36).slice(2)); } catch (e) { id = 'ls_' + Date.now(); }
      try { localStorage.setItem(key,id); } catch (e) {}
    }
    return id.slice(0,80);
  }

  function safeCode(v) { return String(v || '').trim().toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 64); }
  function safeHandle(v) { return String(v || '').trim().replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 128); }
  function clean(v, n) { return String(v || '').trim().slice(0, n || 160); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[c];
    });
  }
  function money(cents) { return L.formatMoney ? L.formatMoney(cents) : (Number(cents || 0) / 100).toFixed(2) + ' $'; }
  function analytics(name, detail) {
    detail = detail || {};
    if (!privacyAllows('analytics')) return;
    try { document.dispatchEvent(new CustomEvent('lasiren:' + name, { detail: detail })); } catch (e) {}
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event:'lasiren_' + name }, detail)); } catch (e) {}
    if (lagoonBackendEnabled() && detail.sirene && /^sirene_(visit|product_click|hotspot_click|share|add_to_cart|full_look_add)$/.test(name)) {
      try {
        fetch(lagoonApi('/public/event'), {
          method:'POST', credentials:'same-origin', keepalive:true,
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({ event:name, sirene:safeCode(detail.sirene), product:safeHandle(detail.product || ''), session:lagoonSessionId() })
        }).catch(function () {});
      } catch (e) {}
    }
  }
  function setCookie(name, value, days) {
    var maxAge = (days || REF_DAYS) * 86400;
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;max-age=' + maxAge + ';SameSite=Lax';
  }
  function getUtm() {
    var q = new URLSearchParams(location.search);
    return {
      source: clean(q.get('utm_source'), 60),
      medium: clean(q.get('utm_medium'), 60),
      campaign: clean(q.get('utm_campaign'), 80)
    };
  }
  function updateCartAttribution(code, name, source, attributedAt, signedToken) {
    if (!code || !privacyAllows('marketing')) return Promise.resolve();
    var utm = getUtm();
    var attrs = {
      'Sirene': code,
      'Sirene Name': clean(name, 80),
      'Sirene Source': clean(source || 'Lagoon', 40),
      'Sirene Landing': clean(location.pathname, 120),
      'Sirene Attributed At': clean(attributedAt || new Date().toISOString(), 40),
      'Sirene Attribution Token': clean(signedToken || '', 512)
    };
    if (utm.source) attrs['Sirene UTM Source'] = utm.source;
    if (utm.medium) attrs['Sirene UTM Medium'] = utm.medium;
    if (utm.campaign) attrs['Sirene UTM Campaign'] = utm.campaign;
    return fetch((L.routes && L.routes.cart_update) || rootPath('cart/update.js'), {
      method: 'POST',
      credentials:'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }
  function clearReferralAttribution() {
    try {
      localStorage.removeItem('lasiren_sirene_ref_v13');
      localStorage.removeItem('lasiren_sirene_ref_v12');
      localStorage.removeItem('lasiren_sirene_ref');
      localStorage.removeItem('lasiren_sirene_name');
    } catch (e) {}
    try { document.cookie = 'lasiren_sirene_ref=;path=/;max-age=0;SameSite=Lax'; } catch (e) {}
    var attrs = {
      'Sirene':'', 'Sirene Name':'', 'Sirene Source':'', 'Sirene Landing':'', 'Sirene Attributed At':'', 'Sirene Attribution Token':'',
      'Sirene UTM Source':'', 'Sirene UTM Medium':'', 'Sirene UTM Campaign':''
    };
    try {
      return fetch((L.routes && L.routes.cart_update) || rootPath('cart/update.js'), {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({ attributes:attrs })
      }).catch(function () {});
    } catch (e) { return Promise.resolve(); }
  }

  function saveReferral(code, name, source, signed) {
    if (!code || !privacyAllows('marketing')) return null;
    var now = Date.now();
    var signedAt = signed && Date.parse(signed.attributedAt || '');
    var signedExpires = signed && Date.parse(signed.expiresAt || '');
    var record = {
      code:code,
      name:clean((signed && signed.displayName) || name,80),
      source:clean(source,40),
      attributedAt:Number.isFinite(signedAt) ? new Date(signedAt).toISOString() : new Date(now).toISOString(),
      expires:Number.isFinite(signedExpires) ? signedExpires : now + REF_DAYS * 86400000,
      token:clean(signed && signed.token,512)
    };
    try {
      localStorage.setItem('lasiren_sirene_ref_v13', JSON.stringify(record));
      localStorage.removeItem('lasiren_sirene_ref_v12');
      localStorage.removeItem('lasiren_sirene_ref');
      localStorage.removeItem('lasiren_sirene_name');
    } catch (e) {}
    setCookie('lasiren_sirene_ref', code, Math.max(1, Math.ceil((record.expires - now) / 86400000)));
    return record;
  }
  function requestSignedAttribution(code) {
    if (!lagoonBackendEnabled() || !code) return Promise.resolve(null);
    return fetch(lagoonApi('/public/attribution?code=' + encodeURIComponent(code)), {
      method:'GET', credentials:'same-origin', cache:'no-store', headers:{'Accept':'application/json'}
    }).then(function (r) {
      if (!r.ok) throw new Error('attribution_unavailable');
      return r.json();
    }).then(function (data) {
      if (!data || !data.ok || !data.token || safeCode(data.code) !== safeCode(code)) throw new Error('invalid_attribution');
      return data;
    });
  }
  function activateReferral(code, name, source) {
    code = safeCode(code);
    if (!code || !privacyAllows('marketing')) return Promise.resolve(null);
    if (!lagoonBackendEnabled()) {
      var localRecord = saveReferral(code, name, source, null);
      return updateCartAttribution(code, localRecord ? localRecord.name : name, source, localRecord && localRecord.attributedAt, '').then(function () { return localRecord; });
    }
    return requestSignedAttribution(code).then(function (signed) {
      var record = saveReferral(code, name, source, signed);
      if (!record || !record.token) throw new Error('signed_attribution_required');
      return updateCartAttribution(code, record.name, source, record.attributedAt, record.token).then(function () { return record; });
    }).catch(function () { return null; });
  }
  function refreshCartAttribution(code, name, source) {
    code = safeCode(code);
    if (!code || !privacyAllows('marketing')) return Promise.resolve(null);
    var stored = getStoredReferral();
    if (stored && safeCode(stored.code) === code && (!lagoonBackendEnabled() || stored.token)) {
      return updateCartAttribution(code, stored.name || name, source || stored.source, stored.attributedAt, stored.token || '').then(function () { return stored; });
    }
    return activateReferral(code, name, source || 'Lagoon');
  }

  function getStoredReferral() {
    try {
      var record = JSON.parse(localStorage.getItem('lasiren_sirene_ref_v13') || localStorage.getItem('lasiren_sirene_ref_v12') || 'null');
      if (record && safeCode(record.code) && Number(record.expires) > Date.now()) return record;
      if (record && Number(record.expires) <= Date.now()) {
        localStorage.removeItem('lasiren_sirene_ref_v13');
      localStorage.removeItem('lasiren_sirene_ref_v12');
        localStorage.removeItem('lasiren_sirene_ref');
        localStorage.removeItem('lasiren_sirene_name');
      }
    } catch (e) {}
    /* One-time V11/V12 migration: legacy values receive a fresh finite window, then the legacy keys are removed. */
    try {
      var legacy = safeCode(localStorage.getItem('lasiren_sirene_ref'));
      var legacyName = clean(localStorage.getItem('lasiren_sirene_name'),80);
      if (legacy) return saveReferral(legacy, legacyName, 'Legacy migration');
    } catch (e) {}
    return null;
  }
  L.ensureLagoonAttribution = function () {
    if (!privacyReady) return privacyReadyPromise.then(function () { return L.ensureLagoonAttribution(); });
    if (!privacyAllows('marketing')) return Promise.resolve(null);
    var q = new URLSearchParams(location.search);
    var lagoon = $('[data-sirene-lagoon]');
    var pageCode = lagoon ? safeCode(lagoon.dataset.lagoonDefaultCode) : '';
    var code = pageCode || safeCode(q.get('ref') || q.get('sirene'));
    var pageName = lagoon ? clean(lagoon.dataset.lagoonDefaultName, 80) : '';
    var name = pageCode ? pageName : clean(q.get('name') || pageName, 80);
    var source = pageCode ? 'Permanent Lagoon' : (code ? 'Siren shared link' : 'Stored referral');
    if (code) return refreshCartAttribution(code, name, source);
    var stored = getStoredReferral();
    if (stored && stored.code) return refreshCartAttribution(stored.code, stored.name, stored.source || source);
    return Promise.resolve(null);
  };

  function rememberReferral() {
    var q = new URLSearchParams(location.search);
    var lagoon = $('[data-sirene-lagoon]');
    var queryCode = safeCode(q.get('ref') || q.get('sirene'));
    var pageCode = lagoon ? safeCode(lagoon.dataset.lagoonDefaultCode) : '';
    /* A permanent Lagoon page is authoritative: query parameters may build a Look,
       but they may not impersonate another Siren or overwrite the profile identity. */
    var incoming = pageCode || queryCode;
    var queryName = clean(q.get('name'), 80);
    var pageName = lagoon ? clean(lagoon.dataset.lagoonDefaultName, 80) : '';
    var name = pageCode ? pageName : (queryName || pageName);
    if (incoming) {
      var source = pageCode ? 'Permanent Lagoon' : 'Siren shared link';
      activateReferral(incoming, name, source);
      analytics('sirene_visit', { sirene:incoming, source:source });
      return { code:incoming, name:name, source:source };
    }
    var stored = getStoredReferral();
    if (stored && stored.code) {
      if (lagoonBackendEnabled() && !stored.token) activateReferral(stored.code, stored.name, stored.source || 'Stored referral');
      else updateCartAttribution(stored.code, stored.name, stored.source || 'Stored referral', stored.attributedAt, stored.token || '');
    }
    return stored;
  }
  function withRef(url, ref, name) {
    try {
      var u = new URL(url, location.origin);
      if (ref) u.searchParams.set('ref', ref);
      if (name) u.searchParams.set('name', clean(name, 80));
      return u.toString();
    } catch (e) { return url; }
  }

  function getAvailableVariants(p) { return (p.variants || []).filter(function (v) { return v.available; }); }
  function productCard(p, ref, name) {
    var variants = getAvailableVariants(p);
    var selector = '';
    var displayPrice = variants[0] ? variants[0].price : p.price;
    if (variants.length > 1) {
      selector = '<select data-sirene-variant aria-label="' + (isFr ? 'Choisir une variante' : 'Choose a variant') + '">' +
        '<option value="" selected disabled>' + (isFr ? 'Choisir une option' : 'Choose an option') + '</option>' +
        variants.map(function (v) {
          return '<option value="' + esc(String(v.id)) + '" data-price="' + esc(String(v.price)) + '">' + esc(v.title) + ' · ' + money(v.price) + '</option>';
        }).join('') + '</select><small class="ls-v13-variant-error" data-variant-error hidden></small>';
    }
    var action = variants.length
      ? '<button class="ls-bouton" type="button" data-sirene-selection-add>' + (isFr ? 'Ajouter au panier' : 'Add to cart') + '</button>'
      : '<button class="ls-bouton" type="button" disabled>' + (isFr ? 'Épuisé' : 'Sold out') + '</button>';
    var img = p.featured_image ? '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
    var href = withRef(rootPath('products/' + p.handle), ref, name);
    return '<article class="ls-sirene-shop-card" data-product-handle="' + esc(p.handle) + '">' +
      '<a class="ls-sirene-shop-media" href="' + href + '">' + img + '</a>' +
      '<div class="ls-sirene-shop-copy"><h2><a href="' + href + '">' + esc(p.title) + '</a></h2>' +
      '<strong data-sirene-card-price>' + money(displayPrice) + '</strong>' + selector + action + '</div></article>';
  }
  function fetchProduct(handle) {
    return fetch(rootPath('products/' + encodeURIComponent(handle) + '.js'), { headers: { 'Accept':'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
      .catch(function () { return null; });
  }
  function addVariant(id, qty) {
    if (!id) return Promise.reject(new Error('variant'));
    if (L.addToCart) return Promise.resolve(L.addToCart(id, qty || 1, true));
    return fetch((L.routes && L.routes.cart_add) || rootPath('cart/add.js'), {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:String(id),quantity:qty || 1}]})
    });
  }
  function bindProductGrid(grid, ref, name) {
    if (!grid || grid.dataset.boundSirene === 'true') return;
    grid.dataset.boundSirene = 'true';
    grid.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-sirene-variant]');
      if (!sel) return;
      var card = sel.closest('.ls-sirene-shop-card');
      var price = $('[data-sirene-card-price]', card);
      var opt = sel.options[sel.selectedIndex];
      var err = $('[data-variant-error]', card);
      if (price && opt && opt.value) price.textContent = money(opt.dataset.price);
      if (err) { err.hidden = true; err.textContent = ''; }
      card && card.classList.remove('ls-v13-needs-variant');
    });
    grid.addEventListener('click', function (e) {
      var productLink = e.target.closest('.ls-sirene-shop-media, .ls-sirene-shop-copy h2 a');
      if (productLink) {
        var linkCard = productLink.closest('.ls-sirene-shop-card');
        analytics('sirene_product_click', { sirene:ref, product:linkCard && linkCard.dataset.productHandle });
        return;
      }
      var btn = e.target.closest('[data-sirene-selection-add]');
      if (!btn) return;
      var card = btn.closest('.ls-sirene-shop-card');
      var handle = card && card.dataset.productHandle;
      if (!handle) return;
      fetchProduct(handle).then(function (p) {
        if (!p) return;
        var sel = $('[data-sirene-variant]', card);
        var first = getAvailableVariants(p)[0];
        var id = sel ? sel.value : (first || {}).id;
        if (sel && !id) {
          var err = $('[data-variant-error]', card);
          if (err) { err.textContent = isFr ? 'Choisis la taille/couleur avant d’ajouter.' : 'Choose the size/color before adding.'; err.hidden = false; }
          card.classList.add('ls-v13-needs-variant');
          sel.focus();
          return;
        }
        if (!id) return;
        btn.disabled = true;
        return addVariant(id, 1)
          .then(function () { analytics('sirene_add_to_cart', { sirene:ref, product:handle }); })
          .finally(function () { btn.disabled = false; });
      });
    });
  }

  function initPortal() {
    var portal = $('[data-sirene-portal]');
    var builder = $('[data-sirene-builder]');
    if (!portal || !builder) return;

    var code = safeCode(builder.dataset.sireneCode);
    var name = clean(builder.dataset.sireneName || 'Sirène', 80);
    var base = (builder.dataset.lagoonUrl || '').trim();
    var level = clean(builder.dataset.sireneLevel, 80);
    var territory = clean(builder.dataset.sireneTerritory, 100);
    var bio = clean(builder.dataset.sireneBio, 180);
    var max = parseInt(builder.dataset.maxProducts || '12', 10);
    var checks = $$('[data-sirene-product-check]', builder);
    var count = $('[data-sirene-selected-count]', portal);
    var search = $('[data-sirene-search]', builder);
    var filter = $('[data-sirene-filter]', builder);
    var error = $('[data-sirene-error]', builder);
    var lookName = $('[data-sirene-look-name]', builder);
    var storageKey = 'lasiren_portal_selection_' + code;
    var contentProducts = $('[data-sirene-content-products]', portal);
    var savePicks = $('[data-sirene-save-picks]', portal);
    var syncStatus = $('[data-sirene-sync-status]', portal);
    var recentPosts = $('[data-lagoon-my-posts]', portal);
    var ledgerRoot = $('[data-lagoon-ledger]', portal);

    function selected() { return checks.filter(function (c) { return c.checked; }); }
    function selectedHandles() { return selected().map(function (c) { return c.value; }); }
    function selectedInfo() {
      return selected().map(function (c) {
        var card = c.closest('[data-sirene-product]');
        return {
          handle:c.value,
          title:clean(card && card.dataset.title, 120),
          image:clean(card && card.dataset.productImage, 300),
          price:clean(card && card.dataset.productPrice, 40)
        };
      });
    }
    function updateCount() {
      var n = selected().length;
      if (count) count.textContent = n;
      checks.forEach(function (c) {
        var card = c.closest('[data-sirene-product]');
        if (card) card.classList.toggle('selected', c.checked);
        c.disabled = !c.checked && n >= max;
      });
      try { localStorage.setItem(storageKey, JSON.stringify(selectedHandles())); } catch (e) {}
      renderContentProductChoices();
    }
    try {
      var saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
      checks.forEach(function (c) { c.checked = saved.indexOf(c.value) > -1; });
    } catch (e) {}
    checks.forEach(function (c) { c.addEventListener('change', updateCount); });

    function setChecksFromHandles(handles) {
      handles = Array.isArray(handles) ? handles : [];
      checks.forEach(function (c) { c.checked = handles.indexOf(c.value) > -1; });
      updateCount();
    }
    function formatBackendMoney(amount, currency) {
      try { return new Intl.NumberFormat(isFr ? 'fr-CA' : 'en-CA', {style:'currency',currency:currency || 'CAD'}).format(Number(amount || 0)); }
      catch (e) { return Number(amount || 0).toFixed(2) + ' ' + (currency || 'CAD'); }
    }
    function formatCurrencyBreakdown(rows, fallbackAmount, fallbackCurrency) {
      rows = Array.isArray(rows) ? rows.filter(function (r) { return r && Number(r.amount || 0) !== 0; }) : [];
      if (!rows.length) return formatBackendMoney(fallbackAmount || 0, fallbackCurrency || 'CAD');
      return rows.map(function (r) { return formatBackendMoney(r.amount, r.currency); }).join(' · ');
    }
    function renderBackendMe(data) {
      if (!data || !data.ok) return;
      if (Array.isArray(data.picks)) setChecksFromHandles(data.picks.map(function (p) { return p.handle; }));
      var st = data.stats || {};
      var map = {
        visits30d:st.visits30d,
        clicks30d:st.clicks30d,
        orders30d:st.orders30d,
        conversionRate30d:(Number(st.conversionRate30d || 0)).toFixed(2).replace(/\.00$/,'') + ' %',
        sales30d:formatCurrencyBreakdown(st.salesByCurrency, st.sales30d, st.currency),
        commissionPending:formatCurrencyBreakdown(st.commissionPendingByCurrency, st.commissionPending, st.currency)
      };
      Object.keys(map).forEach(function (k) { var el=$('[data-lagoon-stat="'+k+'"]',portal); if(el && map[k] != null) el.textContent=map[k]; });
      if (recentPosts) {
        var posts = Array.isArray(data.posts) ? data.posts : [];
        recentPosts.innerHTML = posts.length ? posts.slice(0,8).map(function (p) {
          var label = p.status === 'published' ? (isFr?'Publié':'Published') : p.status === 'rejected' ? (isFr?'À reprendre':'Needs changes') : p.status === 'withdrawn' ? (isFr?'Retiré':'Withdrawn') : (isFr?'En révision':'In review');
          var canWithdraw = ['pending','rejected','published'].indexOf(String(p.status)) !== -1;
          return '<article class="ls-v12-submission"><span class="status-'+esc(p.status)+'">'+esc(label)+'</span><strong>'+esc(p.look_name || (isFr?'Publication Lagon':'Lagoon post'))+'</strong><small>'+esc(p.caption || '')+'</small>'+(p.rejection_reason?'<em>'+esc(p.rejection_reason)+'</em>':'')+(canWithdraw?'<button type="button" class="ls-v13-withdraw-post" data-lagoon-withdraw-post="'+esc(p.id)+'">'+(isFr?'Retirer de mon Lagon':'Remove from my Lagoon')+'</button>':'')+'</article>';
        }).join('') : '<p class="ls-v12-empty-small">'+(isFr?'Aucune publication soumise pour le moment.':'No submitted content yet.')+'</p>';
      }
      if (ledgerRoot) {
        var ledger = Array.isArray(data.ledger) ? data.ledger : [];
        ledgerRoot.innerHTML = ledger.length ? ledger.slice(0,10).map(function (x) {
          var sign = Number(x.amount) >= 0 ? '+' : '−';
          var typeLabel = x.entry_type === 'refund' ? (isFr?'Remboursement':'Refund') : x.entry_type === 'cancel' ? (isFr?'Ajustement annulation':'Cancellation adjustment') : (isFr?'Vente attribuée':'Attributed sale');
          var statusLabels = isFr ? {pending:'En attente',approved:'Validée',paid:'Payée',reversed:'Annulée'} : {pending:'Pending',approved:'Approved',paid:'Paid',reversed:'Reversed'};
          var payout = x.payout_reference ? '<small>'+(isFr?'Paiement: ':'Payout: ')+esc(x.payout_reference)+'</small>' : '';
          return '<div class="ls-v12-ledger-row"><span><strong>'+esc(typeLabel)+'</strong><small>'+esc(x.order_id)+'</small>'+payout+'</span><b>'+sign+formatBackendMoney(Math.abs(Number(x.amount||0)),x.currency)+'</b><em>'+esc(statusLabels[x.status] || x.status)+'</em></div>';
        }).join('') : '<p class="ls-v12-empty-small">'+(isFr?'Les commissions apparaîtront ici après les premières ventes attribuées.':'Commissions will appear here after the first attributed sales.')+'</p>';
      }
      if (syncStatus) syncStatus.textContent = isFr ? 'Lagon synchronisé ✓' : 'Lagoon synced ✓';
    }
    document.addEventListener('lasiren:backend-me-refresh', function (event) {
      if (event && event.detail) renderBackendMe(event.detail);
    });

    if (recentPosts) recentPosts.addEventListener('click', function (event) {
      var button = event.target.closest('[data-lagoon-withdraw-post]');
      if (!button) return;
      var id = clean(button.dataset.lagoonWithdrawPost, 100);
      if (!id) return;
      var message = isFr ? 'Retirer cette publication de ton Lagon? Le média sera supprimé.' : 'Remove this post from your Lagoon? Its media will be deleted.';
      if (!window.confirm(message)) return;
      button.disabled = true;
      ensureBackendSession().then(function () {
        if (!backendState.csrf) throw new Error('session');
        return fetch(lagoonApi('/me/posts/' + encodeURIComponent(id)), {
          method:'DELETE', credentials:'same-origin', headers:{'Accept':'application/json','X-Lagoon-CSRF':backendState.csrf}
        });
      }).then(function (response) {
        if (!response || !response.ok) throw new Error('withdraw');
        return ensureBackendSession(true);
      }).then(renderBackendMe).catch(function () {
        button.disabled = false;
        button.textContent = isFr ? 'Impossible pour le moment' : 'Unable to remove right now';
      });
    });

    if (String(portal.dataset.lagoonBackend) === 'true') ensureBackendSession().then(renderBackendMe);

    if (savePicks) savePicks.addEventListener('click', function () {
      if (String(portal.dataset.lagoonBackend) !== 'true') {
        if (syncStatus) syncStatus.textContent = isFr ? 'Active le backend pour sauvegarder ton Lagon.' : 'Enable the backend to save your Lagoon.';
        return;
      }
      savePicks.disabled = true;
      if (syncStatus) syncStatus.textContent = isFr ? 'Synchronisation…' : 'Syncing…';
      ensureBackendSession().then(function (session) {
        if (!session || !backendState.csrf) throw new Error('session');
        return fetch(lagoonApi('/me/picks'), { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({handles:selectedHandles(),_lagoon_csrf:backendState.csrf}) });
      }).then(function (r) { if (!r || !r.ok) throw new Error('save'); return r.json(); })
        .then(function (data) { if (syncStatus) syncStatus.textContent = (isFr ? 'Sauvegardé dans ton Lagon · ' : 'Saved to your Lagoon · ') + Number(data.count || 0) + (isFr?' produits':' products'); analytics('sirene_picks_saved',{sirene:code,product_count:Number(data.count||0)}); return ensureBackendSession(true).then(renderBackendMe); })
        .catch(function () { if (syncStatus) syncStatus.textContent = isFr ? 'Impossible de synchroniser pour le moment.' : 'Unable to sync right now.'; })
        .finally(function () { savePicks.disabled = false; });
    });

    function applyFilters() {
      var term = (search ? search.value : '').trim().toLowerCase();
      var universe = filter ? filter.value : '';
      $$('[data-sirene-product]', builder).forEach(function (card) {
        var title = (card.dataset.title || '').toLowerCase();
        var uni = (card.dataset.universe || '').toLowerCase();
        card.hidden = !!((term && title.indexOf(term) === -1) || (universe && uni !== universe));
      });
    }
    if (search) search.addEventListener('input', applyFilters);
    if (filter) filter.addEventListener('change', applyFilters);

    function buildLagoonUrl(requireProducts) {
      var handles = selectedHandles();
      if (!base) return '';
      if (requireProducts && !handles.length) return '';
      var u = new URL(base, location.origin);
      u.searchParams.set('ref', code);
      u.searchParams.set('name', name);
      u.searchParams.set('look', (lookName && lookName.value.trim()) || ((isFr ? 'Les choix de ' : 'The picks of ') + name));
      if (handles.length) u.searchParams.set('p', handles.join(','));
      if (level) u.searchParams.set('level', level);
      if (territory) u.searchParams.set('territory', territory);
      if (bio) u.searchParams.set('bio', bio);
      return u.toString();
    }

    function renderContentProductChoices() {
      if (!contentProducts) return;
      var info = selectedInfo();
      var previous = {};
      $$('[data-content-product-tag]', contentProducts).forEach(function (c) { if (c.checked) previous[c.value] = true; });
      if (!info.length) {
        contentProducts.innerHTML = '<small>' + (isFr ? 'Choisis d’abord des produits dans « Mes produits ».' : 'Choose products in “My Products” first.') + '</small>';
        document.dispatchEvent(new CustomEvent('lasiren:content-products-changed'));
        return;
      }
      contentProducts.innerHTML = info.map(function (p) {
        return '<label class="ls-v11-product-tag"><input type="checkbox" value="' + esc(p.handle) + '" data-content-product-tag data-title="' + esc(p.title) + '" data-image="' + esc(p.image) + '" ' + (previous[p.handle] ? 'checked' : '') + '><span>' + (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') + '<b>' + esc(p.title) + '</b><small>' + esc(p.price) + '</small></span></label>';
      }).join('');
      document.dispatchEvent(new CustomEvent('lasiren:content-products-changed'));
    }

    var generate = $('[data-sirene-generate]', builder);
    if (generate) generate.addEventListener('click', function () {
      var value = buildLagoonUrl(true);
      if (!value) {
        if (error) { error.hidden = false; error.textContent = isFr ? 'Choisis au moins un produit avant de créer ton Look.' : 'Choose at least one product before creating your Look.'; }
        return;
      }
      if (error) error.hidden = true;
      var box = $('[data-sirene-share-box]', builder);
      var input = $('[data-sirene-share-url]', builder);
      var preview = $('[data-sirene-preview]', builder);
      if (input) input.value = value;
      if (preview) preview.href = value;
      if (box) box.hidden = false;
      try { localStorage.setItem('lasiren_last_share_' + code, value); } catch (e) {}
      analytics('sirene_look_created', { sirene:code, product_count:selectedHandles().length });
    });

    var openLagoon = $('[data-sirene-open-lagoon]', portal);
    if (openLagoon) openLagoon.addEventListener('click', function () {
      if (!base) return;
      var value = '';
      try { value = localStorage.getItem('lasiren_last_share_' + code) || ''; } catch (e) {}
      var target = value || buildLagoonUrl(false);
      if (target) location.href = target;
    });

    var copyPermanent = $('[data-sirene-copy-permanent]', portal);
    if (copyPermanent) copyPermanent.addEventListener('click', function () {
      var permanentValue = copyPermanent.dataset.url || base;
      try { permanentValue = new URL(permanentValue, location.origin).toString(); } catch (e) {}
      copyText(permanentValue).then(function () {
        copyPermanent.textContent = isFr ? 'Copié ✓' : 'Copied ✓';
        setTimeout(function () { copyPermanent.textContent = isFr ? 'Copier' : 'Copy'; }, 1400);
      });
    });

    var copy = $('[data-sirene-copy]', builder);
    if (copy) copy.addEventListener('click', function () {
      var input = $('[data-sirene-share-url]', builder); if (!input) return;
      copyText(input.value).then(function () {
        copy.textContent = isFr ? 'Copié ✓' : 'Copied ✓';
        setTimeout(function () { copy.textContent = isFr ? 'Copier' : 'Copy'; }, 1600);
      });
    });
    var nativeShare = $('[data-sirene-native-share]', builder);
    if (nativeShare) nativeShare.addEventListener('click', function () {
      var input = $('[data-sirene-share-url]', builder); if (!input) return;
      nativeShareUrl((lookName && lookName.value) || 'LaSirèn Lagoon', input.value);
    });

    updateCount();
    initContentStudio({
      portal:portal,
      builder:builder,
      code:code,
      name:name,
      getProducts:selectedInfo,
      getUrl:function () {
        var current = $('[data-sirene-share-url]', builder);
        return (current && current.value) || buildLagoonUrl(false);
      },
      getLookName:function () { return (lookName && lookName.value.trim()) || ((isFr ? 'Les choix de ' : 'The picks of ') + name); },
      backendEnabled:String(portal.dataset.lagoonBackend) === 'true',
      apiPath:clean(portal.dataset.lagoonApi, 180),
      getCsrf:function () { return ensureBackendSession().then(function () { return backendState.csrf || ''; }); }
    });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text).catch(function () {});
    return new Promise(function (resolve) {
      var ta = document.createElement('textarea'); ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      ta.remove(); resolve();
    });
  }
  function nativeShareUrl(title, url) {
    if (navigator.share) return navigator.share({ title:title, url:url }).catch(function () {});
    return copyText(url);
  }

  function initContentStudio(ctx) {
    var studio = $('[data-sirene-content-studio]', ctx.portal || document);
    if (!studio) return;
    var input = $('[data-sirene-content-file]', studio);
    var image = $('[data-sirene-content-image]', studio);
    var video = $('[data-sirene-content-video]', studio);
    var empty = $('[data-sirene-upload-empty]', studio);
    var changeMedia = $('[data-sirene-change-media]', studio);
    var caption = $('[data-sirene-content-caption]', studio);
    var prepare = $('[data-sirene-content-prepare]', studio);
    var reset = $('[data-sirene-content-reset]', studio);
    var result = $('[data-sirene-content-result]', studio);
    var resultTitle = $('[data-sirene-content-result-title]', studio);
    var shareCopy = $('[data-sirene-content-share-copy]', studio);
    var copy = $('[data-sirene-content-copy]', studio);
    var productBox = $('[data-sirene-content-products]', studio);
    var layer = $('[data-sirene-hotspot-layer]', studio);
    var hotspotHelp = $('[data-sirene-hotspot-help]', studio);
    var stage = $('[data-sirene-media-stage]', studio);
    var rights = $('[data-sirene-content-rights]', studio);
    var objectUrl = '';
    var positions = {};

    try {
      var draft = JSON.parse(localStorage.getItem('lasiren_content_draft_' + ctx.code) || '{}');
      if (caption && draft.caption) caption.value = draft.caption;
      positions = draft.hotspots || {};
    } catch (e) {}

    function taggedInputs() { return $$('[data-content-product-tag]', productBox || studio).filter(function (c) { return c.checked; }); }
    function enforceTagMax(changed) {
      var tagged = taggedInputs();
      if (tagged.length > 4 && changed) changed.checked = false;
      var n = taggedInputs().length;
      $$('[data-content-product-tag]', productBox || studio).forEach(function (c) { c.disabled = !c.checked && n >= 4; });
      renderHotspots();
    }
    if (productBox) productBox.addEventListener('change', function (e) {
      var c = e.target.closest('[data-content-product-tag]'); if (!c) return;
      enforceTagMax(c);
    });
    document.addEventListener('lasiren:content-products-changed', function () { enforceTagMax(); });

    function taggedData() {
      return taggedInputs().map(function (c, index) {
        var key = c.value;
        if (!positions[key]) positions[key] = { x:25 + ((index * 19) % 55), y:26 + ((index * 17) % 55) };
        return { handle:key, title:clean(c.dataset.title,120), image:clean(c.dataset.image,300), x:positions[key].x, y:positions[key].y };
      });
    }
    function renderHotspots() {
      if (!layer) return;
      var items = taggedData();
      layer.innerHTML = items.map(function (p, i) {
        return '<button type="button" class="ls-v11-edit-hotspot" data-hotspot-handle="' + esc(p.handle) + '" style="left:' + Number(p.x).toFixed(2) + '%;top:' + Number(p.y).toFixed(2) + '%" aria-label="' + esc(p.title) + '"><span>' + (i + 1) + '</span><em>' + esc(p.title) + '</em></button>';
      }).join('');
      if (hotspotHelp) hotspotHelp.hidden = !items.length || (!image || image.hidden);
      bindHotspotDragging();
    }
    function bindHotspotDragging() {
      if (!layer || !stage) return;
      $$('[data-hotspot-handle]', layer).forEach(function (marker) {
        marker.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
        marker.addEventListener('pointerdown', function (e) {
          e.preventDefault(); e.stopPropagation();
          marker.setPointerCapture(e.pointerId);
          marker.classList.add('dragging');
          function move(ev) {
            var rect = stage.getBoundingClientRect();
            var x = Math.max(3, Math.min(97, ((ev.clientX - rect.left) / rect.width) * 100));
            var y = Math.max(3, Math.min(97, ((ev.clientY - rect.top) / rect.height) * 100));
            marker.style.left = x + '%'; marker.style.top = y + '%';
            positions[marker.dataset.hotspotHandle] = { x:x, y:y };
          }
          function up(ev) {
            marker.classList.remove('dragging');
            try { marker.releasePointerCapture(ev.pointerId); } catch (x) {}
            marker.removeEventListener('pointermove', move); marker.removeEventListener('pointerup', up); marker.removeEventListener('pointercancel', up);
            saveDraft();
          }
          marker.addEventListener('pointermove', move); marker.addEventListener('pointerup', up); marker.addEventListener('pointercancel', up);
        });
      });
    }

    if (input) input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (!file) return;
      if (file.size > 80 * 1024 * 1024) {
        alert(isFr ? 'Ce fichier dépasse 80 Mo. Choisis un fichier plus léger.' : 'This file is over 80 MB. Choose a smaller file.');
        input.value = ''; return;
      }
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = URL.createObjectURL(file);
      if (empty) empty.hidden = true;
      if (changeMedia) changeMedia.hidden = false;
      if (file.type.indexOf('video/') === 0) {
        if (image) image.hidden = true;
        if (video) { video.src = objectUrl; video.hidden = false; }
        if (hotspotHelp) hotspotHelp.hidden = true;
      } else {
        if (video) { video.pause(); video.removeAttribute('src'); video.hidden = true; }
        if (image) { image.src = objectUrl; image.alt = file.name; image.hidden = false; }
        renderHotspots();
      }
      saveDraft();
    });

    function getLink() { return ctx.getUrl(); }
    function buildDraftText() {
      var cap = clean(caption ? caption.value : '', 500);
      return (cap ? cap + '\n\n' : '') + (isFr ? '🌊 Entre dans mon Lagon : ' : '🌊 Enter my Lagoon: ') + getLink();
    }
    function saveDraft() {
      var oldDraft = {};
      try { oldDraft = JSON.parse(localStorage.getItem('lasiren_content_draft_' + ctx.code) || '{}'); } catch (e) {}
      var clientId = oldDraft.client_id || '';
      if (!clientId) { try { clientId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('post_' + Date.now().toString(36) + Math.random().toString(36).slice(2)); } catch (e) { clientId='post_'+Date.now(); } }
      var data = { client_id:clientId, caption:clean(caption ? caption.value : '',500), url:getLink(), hotspots:positions, products:taggedData().map(function (p) { return p.handle; }), savedAt:Date.now() };
      try { localStorage.setItem('lasiren_content_draft_' + ctx.code, JSON.stringify(data)); } catch (e) {}
      return data;
    }
    if (caption) caption.addEventListener('input', function () { window.clearTimeout(caption._saveTimer); caption._saveTimer = window.setTimeout(saveDraft, 300); });

    function setResult(title, text) {
      if (resultTitle) resultTitle.textContent = title;
      if (shareCopy) shareCopy.textContent = text || '';
      if (result) result.hidden = false;
    }
    function submitToBackend() {
      var file = input && input.files && input.files[0];
      if (!file) {
        setResult(isFr ? 'Ajoute une photo ou une vidéo.' : 'Add a photo or video.', isFr ? 'Le média est nécessaire avant la soumission.' : 'Media is required before submitting.');
        return Promise.resolve();
      }
      if (!ctx.apiPath) {
        setResult(isFr ? 'Backend non configuré.' : 'Backend not configured.', isFr ? 'Ajoute le chemin App Proxy dans les réglages du thème.' : 'Add the App Proxy path in theme settings.');
        return Promise.resolve();
      }
      var tagged = taggedData();
      if (rights && !rights.checked) {
        setResult(isFr ? 'Confirmation requise.' : 'Confirmation required.', isFr ? 'Confirme tes droits sur le média et les consentements avant de soumettre.' : 'Confirm your media rights and consents before submitting.');
        return Promise.resolve();
      }
      if (!tagged.length) {
        setResult(isFr ? 'Identifie au moins un produit.' : 'Tag at least one product.', isFr ? 'Un contenu shoppable doit relier au moins un produit LaSirèn.' : 'A shoppable post must link at least one LaSirèn product.');
        return Promise.resolve();
      }
      var draftNow = saveDraft();
      var clientId = draftNow.client_id || '';
      if (!clientId) {
        try { clientId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('post_' + Date.now().toString(36) + Math.random().toString(36).slice(2)); } catch (e) { clientId = 'post_' + Date.now(); }
      }
      var fd = new FormData();
      fd.append('media', file);
      fd.append('sirene_code', ctx.code);
      fd.append('sirene_name', ctx.name);
      fd.append('caption', clean(caption ? caption.value : '', 500));
      fd.append('lagoon_url', getLink());
      fd.append('look_name', ctx.getLookName());
      fd.append('client_id', clientId);
      fd.append('rights_confirmed', rights && rights.checked ? 'true' : 'false');
      fd.append('_lagoon_csrf', '');
      fd.append('products', JSON.stringify(tagged.map(function (p) { return p.handle; })));
      fd.append('hotspots', JSON.stringify(tagged.map(function (p) { return { handle:p.handle, x:p.x, y:p.y }; })));
      if (prepare) { prepare.disabled = true; prepare.dataset.originalText = prepare.textContent; prepare.textContent = isFr ? 'Envoi sécurisé…' : 'Secure upload…'; }
      return Promise.resolve(ctx.getCsrf ? ctx.getCsrf() : '').then(function (csrf) {
        if (!csrf) throw new Error('csrf');
        fd.set('_lagoon_csrf', csrf);
        return fetch(ctx.apiPath.replace(/\/$/, '') + '/content', { method:'POST', body:fd, credentials:'same-origin', headers:{'Accept':'application/json'} });
      }).then(function (r) { if (!r.ok) throw new Error('upload'); return r.json(); })
        .then(function (data) {
          setResult(isFr ? 'Soumis à LaSirèn ✓' : 'Submitted to LaSirèn ✓', data && data.message ? data.message : (isFr ? 'Ton contenu est maintenant en attente de modération.' : 'Your content is now pending moderation.'));
          analytics('sirene_content_submitted', { sirene:ctx.code, products:tagged.length });
          try { localStorage.removeItem('lasiren_content_draft_' + ctx.code); } catch (e) {}
          ensureBackendSession(true).then(function (fresh) {
            if (fresh) document.dispatchEvent(new CustomEvent('lasiren:backend-me-refresh', { detail:fresh }));
          });
        })
        .catch(function () {
          setResult(isFr ? 'Soumission impossible pour le moment.' : 'Submission unavailable right now.', isFr ? 'Ton brouillon reste enregistré sur cet appareil. Réessaie plus tard.' : 'Your draft remains saved on this device. Try again later.');
        })
        .finally(function () { if (prepare) { prepare.disabled = false; prepare.textContent = prepare.dataset.originalText || prepare.textContent; } });
    }

    if (prepare) prepare.addEventListener('click', function () {
      saveDraft();
      if (ctx.backendEnabled) return submitToBackend();
      var text = buildDraftText();
      setResult(isFr ? 'Brouillon prêt ✓' : 'Draft ready ✓', text);
      analytics('sirene_content_draft', { sirene:ctx.code, products:taggedData().length });
    });
    if (copy) copy.addEventListener('click', function () {
      var text = (shareCopy && shareCopy.textContent) || buildDraftText();
      copyText(text).then(function () {
        copy.textContent = isFr ? 'Copié ✓' : 'Copied ✓';
        setTimeout(function () { copy.textContent = isFr ? 'Copier le texte + lien' : 'Copy caption + link'; }, 1600);
      });
    });
    if (reset) reset.addEventListener('click', function () {
      if (objectUrl) { URL.revokeObjectURL(objectUrl); objectUrl = ''; }
      if (input) input.value = '';
      if (image) { image.hidden = true; image.removeAttribute('src'); }
      if (video) { video.pause(); video.hidden = true; video.removeAttribute('src'); }
      if (empty) empty.hidden = false;
      if (changeMedia) changeMedia.hidden = true;
      if (caption) caption.value = '';
      $$('[data-content-product-tag]', productBox || studio).forEach(function (c) { c.checked = false; c.disabled = false; });
      positions = {};
      if (layer) layer.innerHTML = '';
      if (hotspotHelp) hotspotHelp.hidden = true;
      if (result) result.hidden = true;
      try { localStorage.removeItem('lasiren_content_draft_' + ctx.code); } catch (e) {}
    });
    renderHotspots();
  }

  function bindFullLook(root, grid, addLook, ref, name) {
    if (!addLook || !root) return;
    var products = Array.isArray(root._lagoonProducts) ? root._lagoonProducts : [];
    addLook.hidden = !products.length;
    if (addLook.dataset.boundFullLook === 'true') return;
    addLook.dataset.boundFullLook = 'true';
    addLook.addEventListener('click', function () {
      var lookName = clean(root._lagoonLookName || (isFr ? 'Look LaSirèn' : 'LaSirèn Look'), 100);
      var lookId = 'lagoon:' + safeCode(ref || 'organic') + ':' + (safeHandle(lookName) || 'look');
      var currentProducts = Array.isArray(root._lagoonProducts) ? root._lagoonProducts : [];
      var cards = grid ? $$('.ls-sirene-shop-card', grid) : [];
      var missingCard = null;
      var items = currentProducts.map(function (p) {
        var card = cards.find(function (c) { return safeHandle(c.dataset.productHandle) === safeHandle(p.handle); });
        var selector = card && $('[data-sirene-variant]', card);
        var variants = getAvailableVariants(p);
        if (selector && !selector.value) {
          missingCard = missingCard || card;
          var err = $('[data-variant-error]', card);
          if (err) { err.textContent = isFr ? 'Choisis cette option pour compléter le Look.' : 'Choose this option to complete the Look.'; err.hidden = false; }
          card.classList.add('ls-v13-needs-variant');
          return null;
        }
        var selected = selector ? variants.find(function (v) { return String(v.id) === String(selector.value); }) : variants[0];
        return selected ? { id:String(selected.id), quantity:1, properties:{ '_LaSiren Look':lookName, '_LaSiren Look ID':lookId, '_LaSiren Siren':safeCode(ref || '') } } : null;
      }).filter(Boolean);
      if (missingCard) {
        var focusSel = $('[data-sirene-variant]', missingCard);
        missingCard.scrollIntoView({behavior:'smooth',block:'center'});
        setTimeout(function () { if (focusSel) focusSel.focus(); }, 350);
        return;
      }
      if (!items.length) return;
      addLook.disabled = true;
      var attributionPrep = typeof L.ensureLagoonAttribution === 'function' ? Promise.resolve(L.ensureLagoonAttribution()).catch(function () { return null; }) : Promise.resolve(null);
      attributionPrep.then(function () {
        return fetch((L.routes && L.routes.cart_add) || rootPath('cart/add.js'), {
          method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:items})
        });
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          addLook.textContent = isFr ? 'Look ajouté ✓' : 'Look added ✓';
          analytics('sirene_full_look_add', { sirene:ref, product_count:items.length });
          if (L.refreshCart) L.refreshCart();
          if (L.openCart) L.openCart();
        })
        .catch(function () {})
        .finally(function () { addLook.disabled = false; });
    });
  }

  function initLagoon() {
    var root = $('[data-sirene-lagoon]');
    if (!root) return;
    var q = new URLSearchParams(location.search);
    var permanentRef = safeCode(root.dataset.lagoonDefaultCode);
    var lockedProfile = !!permanentRef;
    var ref = permanentRef || safeCode(q.get('ref') || q.get('sirene'));
    var name = clean((lockedProfile ? root.dataset.lagoonDefaultName : (q.get('name') || root.dataset.lagoonDefaultName)) || (isFr ? 'Une Sirène' : 'A Siren'), 80);
    var level = clean(lockedProfile ? root.dataset.lagoonDefaultLevel : (q.get('level') || root.dataset.lagoonDefaultLevel), 80);
    var territory = clean(lockedProfile ? root.dataset.lagoonDefaultTerritory : (q.get('territory') || root.dataset.lagoonDefaultTerritory), 100);
    var bio = clean(lockedProfile ? root.dataset.lagoonDefaultBio : (q.get('bio') || root.dataset.lagoonDefaultBio), 220);
    var look = clean(q.get('look') || (isFr ? 'Ses choix LaSirèn' : 'Her LaSirèn picks'), 100);
    root._lagoonLookName = look;
    var queryHandles = String(q.get('p') || '').split(',').map(safeHandle).filter(Boolean).slice(0, 18);
    var defaultHandles = String(root.dataset.lagoonDefaultProducts || '').split(',').map(safeHandle).filter(Boolean).slice(0, 18);
    var handles = queryHandles.length ? queryHandles : defaultHandles;

    var n = $('[data-lagoon-name]', root); if (n && !lockedProfile && q.get('name')) n.textContent = name;
    var b = $('[data-lagoon-bio]', root); if (b && !lockedProfile && q.get('bio')) b.textContent = bio;
    var l = $('[data-lagoon-level]', root); if (l && level) { l.textContent = level; l.hidden = false; }
    var t = $('[data-lagoon-territory]', root); if (t && territory) { t.textContent = territory; t.hidden = false; }
    var c = $('[data-lagoon-code]', root); if (c && ref) { c.textContent = 'Code ' + ref; c.hidden = false; }
    var title = $('[data-lagoon-look-title]', root); if (title) title.textContent = look;
    var avatar = $('[data-lagoon-avatar] span', root);
    if (avatar && !avatar.previousElementSibling) {
      var parts = name.split(/\s+/).filter(Boolean);
      avatar.textContent = ((parts[0] || 'L').charAt(0) + ((parts[1] || parts[0] || 'S').charAt(0))).toUpperCase();
    }

    var postCount = 0;
    $$('[data-lagoon-post]', root).forEach(function (post) {
      var postRef = safeCode(post.dataset.sireneCode);
      var show = !!ref && postRef === ref;
      post.hidden = !show;
      if (show) {
        postCount++;
        $$('[data-lagoon-product-link]', post).forEach(function (a) { a.href = withRef(a.href, ref, name); });
      }
    });
    var noPosts = $('[data-lagoon-no-posts]', root); if (noPosts) noPosts.hidden = postCount > 0;

    root.addEventListener('click', function (e) {
      var hotspot = e.target.closest('.ls-v11-public-hotspot');
      if (hotspot) {
        analytics('sirene_hotspot_click', { sirene:ref, product:hotspot.getAttribute('aria-label') || '' });
        return;
      }
      var productLink = e.target.closest('[data-lagoon-product-link]');
      if (productLink) {
        var match = String(productLink.getAttribute('href') || '').match(/\/products\/([a-z0-9_-]+)/i);
        analytics('sirene_product_click', { sirene:ref, product:match ? match[1] : '' });
      }
    });

    $$('[data-lagoon-share]', root).forEach(function (share) {
      share.addEventListener('click', function () {
        var cleanUrl = location.origin + location.pathname;
        nativeShareUrl(name + ' · LaSirèn Lagoon', cleanUrl).then(function () {
          if (!navigator.share) {
            share.textContent = isFr ? 'Lien copié ✓' : 'Link copied ✓';
            setTimeout(function () { share.textContent = isFr ? 'Partager' : 'Share'; }, 1400);
          }
        });
        analytics('sirene_share', { sirene:ref });
      });
    });

    var grid = $('[data-lagoon-product-grid]', root);
    var empty = $('[data-lagoon-empty]', root);
    var addLook = $('[data-lagoon-add-look]', root);
    var serverRendered = grid && grid.dataset.serverRendered === 'true' && !queryHandles.length;

    if (!handles.length) {
      if (grid && !serverRendered) grid.hidden = true;
      if (empty) empty.hidden = false;
      hydratePublicBackend(root, ref, name);
      return;
    }

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) {
        if (grid && !serverRendered) grid.hidden = true;
        if (empty) empty.hidden = false;
        hydratePublicBackend(root, ref, name);
        return;
      }
      root._lagoonProducts = products;
      if (!serverRendered) grid.innerHTML = products.map(function (p) { return productCard(p, ref, name); }).join('');
      bindProductGrid(grid, ref, name);
      bindFullLook(root, grid, addLook, ref, name);
      hydratePublicBackend(root, ref, name);
    });
  }

  function hydratePublicBackend(root, ref, name) {
    if (!root || String(root.dataset.lagoonBackend) !== 'true' || !root.dataset.lagoonApi || !ref) return;
    var api = root.dataset.lagoonApi.replace(/\/$/, '');
    fetch(api + '/public/lagoon?code=' + encodeURIComponent(ref), { headers:{'Accept':'application/json'}, credentials:'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('public lagoon'); return r.json(); })
      .then(function (data) {
        if (!data || !data.ok) return;

        // The signed backend is authoritative once it answers successfully.
        if (data.profile && safeCode(data.profile.code) === ref) {
          var serverName = clean(data.profile.displayName || name, 80);
          var nameNode = $('[data-lagoon-name]', root); if (nameNode && serverName) nameNode.textContent = serverName;
          var levelNode = $('[data-lagoon-level]', root); if (levelNode) { levelNode.textContent = clean(data.profile.level || '',80); levelNode.hidden = !data.profile.level; }
          var territoryNode = $('[data-lagoon-territory]', root); if (territoryNode) { territoryNode.textContent = clean(data.profile.territory || '',100); territoryNode.hidden = !data.profile.territory; }
          name = serverName || name;
        }

        var pickGrid = $('[data-lagoon-product-grid]', root);
        var emptyP = $('[data-lagoon-empty]', root);
        var dynamicAddLook = $('[data-lagoon-add-look]', root);
        var backendPicks = Array.isArray(data.picks) ? data.picks.slice(0,18) : [];
        if (pickGrid) {
          if (!backendPicks.length) {
            root._lagoonProducts = [];
            pickGrid.innerHTML = '';
            pickGrid.hidden = true;
            pickGrid.dataset.serverRendered = 'false';
            if (emptyP) emptyP.hidden = false;
            if (dynamicAddLook) dynamicAddLook.hidden = true;
          } else {
            Promise.all(backendPicks.map(function (p) { return fetchProduct(p.handle); })).then(function (products) {
              products = products.filter(Boolean);
              root._lagoonProducts = products;
              pickGrid.dataset.serverRendered = 'false';
              if (!products.length) {
                pickGrid.innerHTML = '';
                pickGrid.hidden = true;
                if (emptyP) emptyP.hidden = false;
                if (dynamicAddLook) dynamicAddLook.hidden = true;
                return;
              }
              pickGrid.hidden = false;
              pickGrid.innerHTML = products.map(function (p) { return productCard(p, ref, name); }).join('');
              bindProductGrid(pickGrid, ref, name);
              bindFullLook(root, pickGrid, dynamicAddLook, ref, name);
              if (emptyP) emptyP.hidden = true;
            });
          }
        }

        var posts = $('[data-lagoon-posts]', root); if (!posts) return;
        $$('[data-lagoon-post]', posts).forEach(function (staticPost) { staticPost.hidden = true; });
        var noPosts = $('[data-lagoon-no-posts]', root);
        var dynamic = $('[data-lagoon-backend-posts]', posts);
        if (!dynamic) { dynamic = document.createElement('div'); dynamic.dataset.lagoonBackendPosts = 'true'; dynamic.className = 'ls-v11-backend-posts'; posts.prepend(dynamic); }
        var backendPosts = Array.isArray(data.posts) ? data.posts.slice(0,24) : [];
        if (!backendPosts.length) {
          dynamic.innerHTML = '';
          if (noPosts) noPosts.hidden = false;
          return;
        }
        if (noPosts) noPosts.hidden = true;
        dynamic.innerHTML = backendPosts.map(function (post) {
          var tagged = Array.isArray(post.products) ? post.products.slice(0,4) : [];
          var hotspots = Array.isArray(post.hotspots) ? post.hotspots : [];
          var hotspotHtml = tagged.map(function (p, i) {
            var h = hotspots.find(function (x) { return safeHandle(x.handle) === safeHandle(p.handle); }) || hotspots[i] || {x:25 + i*15,y:30 + i*12};
            return '<a class="ls-v11-public-hotspot" data-lagoon-product-link href="' + esc(withRef(p.url || rootPath('products/' + p.handle), ref, name)) + '" style="left:' + Number(h.x || 50) + '%;top:' + Number(h.y || 50) + '%" aria-label="' + esc(p.title || p.handle) + '"><span>' + (i+1) + '</span></a>';
          }).join('');
          var productHtml = tagged.map(function (p, i) {
            return '<a href="' + esc(withRef(p.url || rootPath('products/' + p.handle), ref, name)) + '" data-lagoon-product-link>' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '<span><strong><b>' + (i+1) + '</b> ' + esc(p.title || p.handle) + '</strong><small>' + esc(p.price || '') + '</small></span></a>';
          }).join('');
          var mediaHtml = post.mediaType === 'video' && post.video ? '<video src="' + esc(post.video) + '" controls playsinline preload="metadata"></video>' : (post.image ? '<img src="' + esc(post.image) + '" alt="' + esc(post.caption || '') + '" loading="lazy">' : '');
          return '<article class="ls-lagoon-post ls-v11-lagoon-post ls-v12-lagoon-post"><div class="ls-lagoon-post-media">' + mediaHtml + '<span class="ls-lagoon-post-badge">SHOP THE LOOK</span><div class="ls-v11-public-hotspots">' + hotspotHtml + '</div></div><div class="ls-lagoon-post-copy">' + (post.caption ? '<p>' + esc(post.caption) + '</p>' : '') + '<div class="ls-lagoon-post-products">' + productHtml + '</div></div></article>';
        }).join('');
      })
      .catch(function () {});
  }

  function initSelectionLegacy() {
    var root = $('[data-sirene-selection]'); if (!root) return;
    var q = new URLSearchParams(location.search);
    var ref = safeCode(q.get('ref') || q.get('sirene'));
    var name = clean(q.get('name') || (isFr ? 'une Sirène' : 'a Siren'), 80);
    var look = clean(q.get('look') || ((isFr ? 'La sélection de ' : 'The selection of ') + name), 100);
    var handles = String(q.get('p') || '').split(',').map(safeHandle).filter(Boolean).slice(0, 18);
    var title = $('[data-sirene-selection-title]', root); if (title) title.textContent = look;
    var by = $('[data-sirene-selection-byline]', root); if (by) by.textContent = (isFr ? 'Choisie par ' : 'Curated by ') + name + (isFr ? ' · magasine ses coups de cœur LaSirèn.' : ' · shop her LaSirèn favorites.');
    var pill = $('[data-sirene-ref-pill]', root); if (pill && ref) { pill.hidden = false; $('[data-sirene-ref-code]', pill).textContent = ref; }
    var grid = $('[data-sirene-selection-grid]', root), empty = $('[data-sirene-selection-empty]', root);
    if (!handles.length) { if (grid) grid.hidden = true; if (empty) empty.hidden = false; return; }
    Promise.all(handles.map(fetchProduct)).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) { if (grid) grid.hidden = true; if (empty) empty.hidden = false; return; }
      grid.innerHTML = products.map(function (p) { return productCard(p, ref, name); }).join('');
      bindProductGrid(grid, ref, name);
    });
  }

  function boot() { initPortal(); initLagoon(); initSelectionLegacy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  loadPrivacyApi(function () {
    if (privacyAllows('marketing')) rememberReferral();
    else clearReferralAttribution();
  });
  document.addEventListener('visitorConsentCollected', function () {
    if (privacyAllows('marketing')) rememberReferral();
    else clearReferralAttribution();
  });
})();
